export var RoutingActionTypes;
(function (RoutingActionTypes) {
    RoutingActionTypes["RECEIVE_FOS_ROUTES"] = "RECEIVE_FOS_ROUTES";
    RoutingActionTypes["CREATE_ROUTE"] = "CREATE_ROUTE";
    RoutingActionTypes["CREATE_ROUTE_SLUGS"] = "CREATE_ROUTE_SLUGS";
})(RoutingActionTypes || (RoutingActionTypes = {}));
